import "./../../levels/common.blocks/user-pic/user-pic.react.js";
import _userPic_provider_yandexTeam from "./../../levels/common.blocks/user-pic/_provider/user-pic_provider_yandex-team.react.js";

var UserPic = _userPic_provider_yandexTeam.applyDecls();

import "./../../levels/common.blocks/user-pic/user-pic.css";
import "./../../levels/common.blocks/user-pic/_has-plus/user-pic_has-plus_yes.css";


export default UserPic;